exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.school_free_trial_onboarding_overlay__title--1bXTG {\n}\n\n.school_free_trial_onboarding_overlay__title--1bXTG .school_free_trial_onboarding_overlay__strong--1U8Fu {\n\t\tfont-family: 'avenirheavy', Helvetica, Arial, sans-serif;\n\t}\n\n.school_free_trial_onboarding_overlay__asset--fQp2X {\n\tmargin: 0 32px;\n\ttext-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"title": "school_free_trial_onboarding_overlay__title--1bXTG",
	"strong": "school_free_trial_onboarding_overlay__strong--1U8Fu",
	"asset": "school_free_trial_onboarding_overlay__asset--fQp2X"
};